<template>
  <div @keydown.enter.stop.prevent="()=>{}" class="quill-question" :class="{['quill-question-' + question.name]:true, isAccordion}">
    <label v-if="sectionPrompt" class="section-label" :class="[!!question?.helptext && !hideHelp ? 'pb-1' : 'pb-2']">
      <span class="fw-bold fs-18 fs-lg-20" v-html="sectionPrompt"/>
      <i v-if="!!question?.tooltip">
        <svg width="15" height="15" color="red">
          <use href="/sprite.svg#info"/>
        </svg>
        <span  class="question-help-tooltip" v-html="question?.tooltip"/>
      </i>
    </label>

    <label  v-if="question.type !== 'switch' && (!hidePrompt && !forcePromptPlaceholder)" :class="[!!question?.helptext && !hideHelp ? 'pb-1' : 'pb-2']">
      <span class="prompt-label" :class="`${question?.section || isAccordion ? 'fw-reg':'fw-bold'} ${question?.section || isAccordion ? 'fs-16 fs-lg-18':'fs-18 fs-lg-20'}`" v-html="(showSectionPrompts || !question?.section  || isAccordion) ?  question?.prompt:null"/>
      <i v-if="!!question?.tooltip && !sectionPrompt && ( isAccordion || !question?.section )">
        <svg width="15" height="15" color="red">
          <use href="/sprite.svg#info"/>
        </svg>
        <span  class="question-help-tooltip" v-html="question?.tooltip"/>
      </i>
    </label>
    <aside v-if="!!question?.helptext && !hideHelp" style="color:#757575" class="fs-12 pb-2 color-dull" v-html="question.helptext"></aside>

    <component
        ref="displayComponent"
        :is="inputComponent"
        v-bind="componentProps"
        v-if="inputComponent"
        :hasBeenInteractedWith="hasBeenInteractedWith"
        @confirm="$emit('scrollToNextQuestion', {index, question})"
        @update:modelValue="emitChange"
        @field-error="$emit('field-error',{
          field_name: this.question.name,
          hasError: $event
        })"
        @address-error="$emit('field-error',{
        field_name: $event.field,
        hasError: $event.hasError
        })"
        @user-interaction="$emit('user-interaction', question.name)"
        @address-change="$emit('address-change',$event)"
        @loadVgsField="$emit('loadVgsField', $event)"
        @remove-field="$emit('removeVgsField', $event)"
        @prelim-value-update="$emit('prelim-update', {
          field_name: this.question.name,
          value: $event
        })"
    >
      <template v-slot:helptext="{isConfirm, confirmCb, isError}">
        <div class="d-flex subtext mt-1 mb-1">
          <div class="pe-4 flex-grow-1">
            <div v-if="isError" :class="{errorMessage: hasBeenInteractedWith}" class="subtext preError d-block" v-html="isError"></div>
            <div v-if="(!hideSubText && question.subtext) || (question?.type === 'address' && question.subtext)"
                 class="subtext d-block" v-html="question.subtext"></div>
          </div>
          <div style="min-height: 20px; min-width: 76px">
            <div class="text-end" >
              <div v-if="runningRulesFor"  class="spinner spinner-agency d-inline-block small-spinner">&nbsp;</div>
              <div class="color-agency text-end confirm" v-else-if="isConfirm && !disableConfirm && !runningRulesFor">
                <span class="pe-2"  id="confirmBtn" @click.stop="confirmCb" style="font-size: 14px; max-width: fit-content; text-decoration: underline" role="button">
                  Continue
                </span>
                  <i @click.stop="confirmCb" role="button" style="width: fit-content">
                    <svg width="16" height="16" color="red">
                      <use href="/sprite.svg#confirm-arrow"/>
                    </svg>
                  </i>
              </div>
            </div>
          </div>
        </div>
      </template>
    </component>

    <div v-else>
      <input
          @change="emitChange($event.target.value)"
          class="quill-question-input"
          :name="question.name"
          :value="question.value"
          type="text"
          placeholder=" "
      />
      <span class="quill-question-placeholder">{{
          question.placeholder || "Provide " + question.name
        }}</span>
      <span class="question-type-unknown">{{ question.type }}</span>
    </div>

    <div v-if="groupError" class="subtext errorMessage d-block" v-html="groupError"></div>

    <b class="pt-1">{{ question.error }}</b>
    <u v-if="confirmLinkDispChk(question) && !hideHelp">
      <icon name="check-circled" container="i-16" />
      Confirm?
    </u>

    <em v-if="question.loadingRules" class="float-end spinner spinner-agency"></em>
  </div>
</template>

<script>
import Icon from "@/components/waffle/components/Icon.vue";
import SplitDateInput from "@/components/waffle/components/form-components/SplitDate.vue";
import BoxToggleInput from "@/components/waffle/components/form-components/BoxToggle.vue";
import AutoCompleteInput from "@/components/waffle/components/form-components/AutocompleteInput.vue";
import CounterInput from "@/components/waffle/components/form-components/Counter.vue";
import AddressInput from "@/components/waffle/components/form-components/Address.vue";
import CheckBoxInput from "@/components/waffle/components/form-components/CheckBox.vue";
import CalendarDatePicker from "@/components/waffle/components/form-components/CalendarDatePicker.vue";
import RadioChoiceInput from "@/components/waffle/components/form-components/RadioChoice.vue";
import ReadOnly from "@/components/waffle/components/form-components/ReadOnly.vue";
import {debounce} from "@/components/waffle/utils/debouce";
import ChoicesInput from "@/components/waffle/components/form-components/Choices.vue";
import vgsInput from "@/components/waffle/components/form-components/vgsInput.vue";
import ChipChoicesInput from "@/components/waffle/components/form-components/ChipChoices.vue";
import SwitchInput from "@/components/waffle/components/form-components/SwitchInput.vue";
import VgsInput from "@/components/waffle/components/form-components/vgsInput.vue";

import InputText2 from "@/components/waffle/components/form-components/InputText2.vue";
export default {
  name: "QuestionRender",
  components: {
    Icon,
    SwitchInput,
    vgsInput,
    ChoicesInput,
    ReadOnly,
    AddressInput,
    RadioChoiceInput,
    CalendarDatePicker,
    AutoCompleteInput,
    BoxToggleInput,
    SplitDateInput,
    CounterInput,
    CheckBoxInput,
    ChipChoicesInput,
    InputText2
  },
  setup(props, context) {
    const emitChange = debounce(function (value) {
      context.emit("field-change", {
        fieldValue: value,
        fieldConfig: props.question,
      });
    }, 500)
    return {
      emitChange
    }
  },
  emits: ["field-error", 'address-change', 'field-change', 'loadVgsField', 'removeVgsField', 'scrollToNextQuestion','user-interaction', 'prelim-update'],
  props: [
    "hidePrompt",
    "hideHelp",
    'hideSubText',
    'forcePromptPlaceholder',
    'fields',
    'skipEagerValidation',
    'loadingRules',
    'question',
    'disableConfirm',
    'groupError',
    'index',
    'isVgsFormReady',
    'vgsFieldsReady',
    'vgsFieldState',
    'isAccordion',
    'sectionPrompt',
    'showSectionPrompts',
    'isPopUp',
    'hasBeenInteractedWith',
    'currentActiveQuestion',
    'enableScrolling',
    'runningRulesFor',
    'isRevisiting'
  ],
  computed: {
    inputComponent() {

      switch (this.question.type) {
        case 'choice':
        case 'select_nt':
        case 'select':
        case 'link':
        case 'choice-autocomplete':
          return AutoCompleteInput;
        case 'choices':
          return ChoicesInput;
        case 'calendarDate':
        case 'date-calendar':
          return CalendarDatePicker;
        case 'radio':
          return RadioChoiceInput;
        case 'text':
        case 'text_long':
        case 'text_large':
        case 'text_medium_right':
        case 'number':
        case 'currency':
        case 'money_medium':
        case'phonenumber_large':
        case'phone':
        case 'search':
          return InputText2
        case 'counter':
          return CounterInput;
        case 'toggle':
          return BoxToggleInput;
        case 'checks':
        case 'disclaimer-checkbox':
          return CheckBoxInput;
        case'date':
        case'date_long_pii':
          return SplitDateInput;
        case 'address':
        case 'address-long':
          return AddressInput;
        case 'chip-choices':
          return ChipChoicesInput;
        case 'switch':
          if( this.question?.options?.length < 2){
            return RadioChoiceInput;
          }
          return SwitchInput;
        default:
          if (this.question.type.includes('vgs')) {
            return VgsInput
          }
          return null
      }
    },
    shouldDisable(){
      if(this.currentActiveQuestion?.name === this.question?.name) return false;
      if(this.hasBeenInteractedWith) return false;
      if(this.$attrs.class.includes('grouped') && this.question?.section === this.currentActiveQuestion?.section) return false;
      if(!this.enableScrolling) return false;
      if(this.isRevisiting) return false;
      return true
    },
    componentProps() {
      const defaults = {
        disableConfirm: this.isAccordion || this.disableConfirm,
        question: this.question,
        hideSubText: this.hideSubText,
        disabled: this.shouldDisable,
        forcePromptPlaceholder: this.forcePromptPlaceholder,
        skipEagerValidation: this.skipEagerValidation,
        isAccordion: this.isAccordion
      }
      let custom = {}

      switch (this.question.type) {
        case 'choice':
        case 'select_nt':
        case 'select':
        case 'link':
        case 'choice-autocomplete':
        case 'choices':
          custom = {
            loadingItems: this.loadingRules && (this.question.options && !this.question.options.length),
          }
          if (this.question.type !== 'choice-autocomplete') {
            custom = {
              ...custom,
              disableFiltering: true,
            }
          }
          break;
        case 'number':
        case 'currency':
        case 'money_medium':
        case'phonenumber_large':
        case'phone':
          custom = {
            'isNumber': true
          }
          break;
        case 'address':
        case 'address-long':
          custom = {
            fields: this.fields
          }
          break;
        default:
          if (this.question.type.includes('vgs')) {
            custom = {
              vgsFieldObject: this.vgsFieldsReady[this.question.name],
              isVgsFormReady: this.isVgsFormReady,
              vgsFieldState: this.vgsFieldState,
              index: this.index,
              key: this.index
            }
          }
          break;
      }


      return {...defaults, ...custom}
    }
  },
  methods: {
    confirmLinkDispChk(question) {
      return question === "a";
    },
  },
};
</script>

<style scoped lang="scss">
.subtext {
  font-size: .75rem;
  font: normal normal normal 12px/18px Roboto;
  letter-spacing: 0px;
  margin-bottom: 4px;
  color: #757575
}

.errorMessage {
  color: #BB0000 !important
}

.preError {
  color: #212121
}

.quill-question {
  font-size: 16px;
  position: relative;
  line-height: 1.5;
  border-radius: 5px;

  > label {
    display: flex;
    justify-content: space-between;
    /*margin-right: 10px;*/

    > i {
      font-style: normal;
      position: relative;

      > svg {
        width: 14px;
        height: 14px;
        cursor: pointer;
        float: right;
        margin: 5px;
        border-radius: 50%;
        line-height: 16px;
        opacity: 0.7;

        &:hover {
          color: red;
          box-shadow: 0 1px 5px 0 #9d9b9b;
        }
      }

      > span {
        position: absolute;
        top: 26px;
        right: 0;
        width: 275px;
        font-size: 14px;
        background: #212121;
        color: #ffffff;
        padding: 10px;
        border-radius: 4px;
        text-align: left;
        z-index: 9;
        visibility: hidden;
        transition-delay: .13s;

        &:before {
          content: " ";
          position: absolute;
          top: -8px;
          right: 8px;
          border-width: 4px;
          border-style: solid;
          border-color: transparent transparent black transparent;
        }
      }
    }
  }

  > aside.X {
    font-size: 16px;
    padding-bottom: 8px;
    color: #757575;
  }
  .confirm{
    min-height: 28px;
  }
  > div:not(.subtext):not(.confirm) {
    position: relative;
    min-height: 50px;
    cursor: pointer;

    > .quill-question-input {
      box-sizing: border-box;
      border: 1px solid #ccc;
      border-radius: 3px;
      padding: 16px 5px;
      width: calc(100% - 12px);
      font-size: 16px;
      background: transparent;
      min-height: 100%;
      @media screen and (max-width: 768px) {
        min-width: auto !important;
        flex: 0 0 45% !important;
      }

      &:has(~ .question-type-unknown) {
        border-color: red;
      }

      &:hover {
        /*border: 2px solid #212121; TODO this works for .radio but not for select, so find a common fix*/
        box-shadow: 0 0 0 2px #212121;
        padding: 15px 5px;
      }

      &.radio {
        /*width: 32%;*/
        /*display: inline-block;*/
        padding: 0;
        margin: 3px;
        min-width: 0;
        flex: 1;
        box-sizing: border-box;

        > label {
          padding: 12px 2px;
          cursor: pointer;
          white-space: nowrap;
        }

        input {
          margin: 0 10px;
          transform: scale(1.2);
          accent-color: #212121;
          @media screen and (max-width: 768px) {
            margin: 0 5px;
          }
        }
      }

      label {
        width: 100%;
      }
    }

    > .question-type-unknown {
      color: red;
      position: absolute;
      right: 10px;
      top: -10px;
      background: white;
    }

    .quill-question-placeholder {
      position: absolute;
      padding: 10px 16px;
      line-height: 2em;
      top: 0;
      left: 0;
      color: #757575;
      font-size: 16px;
      pointer-events: none;
      transform: scale(1);
      transition: 0.26s all ease;
    }

    > ul {
      list-style: none;
      padding: 0;
      position: absolute;
      top: calc(100% - 1px);
      background: white;
      border: 1px solid #21212122;
      box-shadow: 3px 3px 10px #21212122;
      width: calc(100% - 12px);
      z-index: 9;
      visibility: hidden;
      transition-delay: 0.13s;

      > li {
        padding: 2px 15px;
        cursor: pointer;

        &:hover {
          font-weight: bold;
          color: #525252;
          background: #98eaf5;
        }

        &.selected {
          font-weight: bold;
          color: #525252;
          background: #ededed;
        }
      }
    }

    > i {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      position: absolute;
      top: calc(50% - 5px);
      right: 26px;
      border-style: solid;
      border-width: 0 3px 3px 0;
      color: #525252;
      transform: rotate(45deg);
      transition: 0.26s all ease;
    }
  }

  > b {
    color: red;
    display: none;
  }

  &.error {
    > b {
      display: block;
    }

    > div {
      border-color: red;
    }
  }

  > u {
    display: block;
    text-align: right;
    text-decoration: underline;
    cursor: pointer;
  }

  .quill-question-posttext {
    font-size: 16px;
    padding-bottom: 8px;
    color: #757575;
  }
}

/*TODO convert to scss*/

.quill-question > label > i > svg:hover:hover ~ span {
  visibility: visible;
  transition-delay: 0.31s;
}

.quill-question > div .quill-question-input:focus,
.quill-question > div .quill-question-input:not(.radio, :placeholder-shown) {
  padding: 25px 8px 5px;
}

.quill-question > div .quill-question-input:focus + .quill-question-placeholder,
.quill-question
> div
.quill-question-input:not(.radio, :placeholder-shown)
+ .quill-question-placeholder {
  font-size: 12px;
  padding: 8px;
}

.quill-question > div .quill-question-input:focus ~ ul {
  /*display: block;*/
  visibility: visible;
  transition-delay: 0.1s;
}

.quill-question > div .quill-question-input:focus ~ i {
  transform: rotate(225deg);
}

.form-floating > .form-control:focus ~ label.form-label-text,
.form-floating > .form-control:focus ~ label {
  font-size: 12px;
  color: #484848;
  padding-top: 1rem;
}

.form-control-disabled:hover {
  border: none;
}

.form-control-enabled:hover {
  border: 2px solid #212121;
}

.invalid {
  border: 1px solid #bb0000;

  &:hover,
  &:focus,
  &:focus-within {
    border: 2px solid #bb0000 !important;
  }
}
</style>
<style scoped>
.waffle.page-context form:not(.non-scrollable) .quill-question {
  scroll-snap-align: start;
}

.waffle.page-context form:not(.non-scrollable) .quill-question.unanswered {
  opacity: 0.26;
}


.waffle.page-context form:not(.non-scrollable) .quill-question:nth-child(n+2 of .quill-question:not(.grouped)) {
  margin-top: calc(15em - 20px) !important;
  scroll-margin: 13em !important;
  @media only screen and (max-width: 990px) {
    scroll-margin: 14em !important;
  }
}

.waffle.page-context form:not(.non-scrollable) .quill-question:nth-child(-n+1 of .unanswered) {
  opacity: 1;
}

.revisiting{
  pointer-events: all !important;
  opacity: 1 !important;
}

.question-help-tooltip {
  max-height:250px;
  overflow-y: auto;

  &:hover{
    visibility: visible;
  }
}

.small-spinner{
  --border-width: 3px !important;
  /* 0.5px's are needed to avoid hard-stopping */
  --mask: radial-gradient(
      farthest-side,
      transparent calc(100% - var(--border-width) - 0.5px),
      #000 calc(100% - var(--border-width) + 0.5px)
  );
  -webkit-mask: var(--mask);
  mask: var(--mask);
  height: 16px !important;
  width: 16px !important
}
</style>